import React, { PureComponent } from "react";
import Container from "@material-ui/core/Container";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  sheet: {},
  drawerPaperRight: {
    height: "100vh",
    paddingTop: 0,
    [theme.breakpoints.up("md")]: { width: "calc(33vw + 20px)" },
    [theme.breakpoints.down("sm")]: { width: "calc(100vw - 70px)" },
    [theme.breakpoints.down("xs")]: { width: "100vw" }
  }
});

const NullComp = () => null;

class Sheet extends PureComponent {
  static defaultProps = {
    content: NullComp,
    menu: undefined,
    nav: NullComp,
    footer: NullComp
  };

  state = {
    menuOpen: false,
    gridClasses: { container: this.props.classes.sheet },
    drawerClasses: { paperAnchorRight: this.props.classes.drawerPaperRight }
  };

  componentDidUpdate = prevProps => {
    if (prevProps.location !== this.props.location) {
      /* eslint-disable-next-line react/no-did-update-set-state */
      this.setState({ menuOpen: false });
    }
  };

  toggle = () => {
    this.setState(state => ({
      menuOpen: !state.menuOpen
    }));
  };

  render = () => {
    const {
      content: Content,
      menu: Menu,
      nav: Nav,
      footer: Footer
    } = this.props;

    return (
      <Container>
        <Nav menuOpen={this.state.menuOpen} onMenuOpen={this.toggle} />
        <Content Login={this.props.login} routes={this.props.routes} />
        {Menu && (
          <SwipeableDrawer
            anchor="right"
            classes={this.state.drawerClasses}
            open={this.state.menuOpen}
            onOpen={this.toggle}
            onClose={this.toggle}
          >
            <Menu menuOpen={this.state.menuOpen} onMenuOpen={this.toggle} />
          </SwipeableDrawer>
        )}

        <Footer />
      </Container>
    );
  };
}

export default withStyles(styles, { name: "LcSheet" })(withRouter(Sheet));
